import { capabilities } from '../../capabilities';
import { getPortalId } from '../../common/utils';
import { defineComponent } from '../../platform/models';
import { MINI_TRIAL_GUIDE_COMPONENT } from '../constants';
import { getStyle } from './internal';
export const MINI_TRIAL_GUIDE_COMPONENT_ID = 'mini-trial-guide-iframe';
export const miniTrialGuideComponentDef = defineComponent(MINI_TRIAL_GUIDE_COMPONENT, {
  name: MINI_TRIAL_GUIDE_COMPONENT,
  path: `/trial-banner/${getPortalId()}/mini-trial-guide`,
  capabilities: [capabilities.NAVIGATE_TO_CAP.getName(), capabilities.SHOW_COMPONENT_CAP.getName(), capabilities.HIDE_COMPONENT_CAP.getName()],
  deferLoading: true,
  initiallyOpen: false,
  iframeProps: {
    id: MINI_TRIAL_GUIDE_COMPONENT_ID,
    style: getStyle(),
    ['data-test-id']: MINI_TRIAL_GUIDE_COMPONENT_ID,
    title: MINI_TRIAL_GUIDE_COMPONENT_ID
  }
});